import React from 'react';
import { formatCurrency } from 'src/utils/stringUtils';
import styled from 'styled-components';

type PointPriceProps = {
  price: number;
};

const PointPrice = (props: PointPriceProps) => {
  const { price } = props;
  return <Price>{formatCurrency(price)}</Price>;
};

const Price = styled.div`
  font-weight: 700;
  text-align: center;
  color: #fff;
  transition: 0.1s all ease-in-out;
`;

export default PointPrice;
